<img class="img-placeholder fade-in"
     [style]="{ 'object-fit': objectFit() }"
     #img
     alt=""
     aria-hidden="true"
     [lazyLoad]="imageUrl()"
     [errorImage]="errorImage()"
     (onStateChange)="myCallbackFunction($event)">
